import * as Sentry from '@sentry/gatsby';
import {
  CONSENT_SERVICES,
  hasConsent,
  subscribeToConsent,
} from 'services/consent';

const isProduction =
  process.env.NODE_ENV && process.env.NODE_ENV.includes('production');

const SENTRY_OPTIONS = {
  dsn: 'https://916f8fbb3722498ab4d2bfd4be40b7a7@sentry.io/1783764',
  environment: process.env.NODE_ENV,
};

let isSentryRunning = false;

// Sentry is in the Functional category, so it may start only once the visitor
// allows it and has to stop when they withdraw. @sentry/gatsby prepends this
// file to every webpack entry, ahead of onClientEntry where the consent store
// starts, so it listens for changes instead of checking once.
const syncSentryWithConsent = () => {
  const isGranted = hasConsent(CONSENT_SERVICES.SENTRY);

  if (isGranted && !isSentryRunning) {
    Sentry.init(SENTRY_OPTIONS);
    isSentryRunning = true;
  } else if (!isGranted && isSentryRunning) {
    Sentry.close();
    isSentryRunning = false;
  }
};

if (isProduction && typeof window !== 'undefined') {
  subscribeToConsent(syncSentryWithConsent);
}
